/**
 * @generated SignedSource<<b64cac22a8998e31f6afd7a418ee23e9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DatasetOverviewPageQuery$variables = {
  owner: string;
  slug: string;
};
export type DatasetOverviewPageQuery$data = {
  readonly datasetBySlug: {
    readonly versions: {
      readonly nodes: ReadonlyArray<{
        readonly viewerCanUpdate: boolean;
        readonly " $fragmentSpreads": FragmentRefs<"DatasetVersionEditSheet" | "DatasetVersionFragment">;
      }>;
    };
    readonly viewerCanUpdate: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"DatasetHelmetFragment">;
  } | null | undefined;
};
export type DatasetOverviewPageQuery = {
  response: DatasetOverviewPageQuery$data;
  variables: DatasetOverviewPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "owner"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "localSlug",
    "variableName": "slug"
  },
  {
    "kind": "Variable",
    "name": "owner",
    "variableName": "owner"
  }
],
v2 = {
  "alias": "viewerCanUpdate",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "UPDATE_DATASET"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"UPDATE_DATASET\")"
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v4 = [
  {
    "kind": "Literal",
    "name": "action",
    "value": "UPDATE_DATASET_VERSION"
  }
],
v5 = {
  "alias": "viewerCanUpdate",
  "args": (v4/*:: as any*/),
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"UPDATE_DATASET_VERSION\")"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = [
  (v6/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DatasetOverviewPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Dataset",
        "kind": "LinkedField",
        "name": "datasetBySlug",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": (v3/*:: as any*/),
            "concreteType": "DatasetVersionConnection",
            "kind": "LinkedField",
            "name": "versions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DatasetVersion",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v5/*:: as any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "DatasetVersionFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "DatasetVersionEditSheet"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "versions(first:1)"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DatasetHelmetFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "DatasetOverviewPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Dataset",
        "kind": "LinkedField",
        "name": "datasetBySlug",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": (v3/*:: as any*/),
            "concreteType": "DatasetVersionConnection",
            "kind": "LinkedField",
            "name": "versions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DatasetVersion",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v5/*:: as any*/),
                  (v6/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rows",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "schema",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "version",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  (v7/*:: as any*/),
                  {
                    "alias": "viewerCanUpdateDatasetVersion",
                    "args": (v4/*:: as any*/),
                    "kind": "ScalarField",
                    "name": "viewerCan",
                    "storageKey": "viewerCan(action:\"UPDATE_DATASET_VERSION\")"
                  },
                  {
                    "alias": "viewerCanCreateDatasetVersion",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "action",
                        "value": "CREATE_DATASET_VERSION"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "viewerCan",
                    "storageKey": "viewerCan(action:\"CREATE_DATASET_VERSION\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Dataset",
                    "kind": "LinkedField",
                    "name": "dataset",
                    "plural": false,
                    "selections": [
                      (v8/*:: as any*/),
                      (v6/*:: as any*/),
                      (v9/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Workspace",
                    "kind": "LinkedField",
                    "name": "workspace",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WorkspaceRunner",
                        "kind": "LinkedField",
                        "name": "editor",
                        "plural": false,
                        "selections": (v10/*:: as any*/),
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*:: as any*/),
                              {
                                "alias": "viewerCanEdit",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "action",
                                    "value": "UPDATE_WORKSPACE"
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "viewerCan",
                                "storageKey": "viewerCan(action:\"UPDATE_WORKSPACE\")"
                              }
                            ],
                            "type": "WorkspaceVersion",
                            "abstractKey": null
                          }
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "versions(first:1)"
          },
          (v9/*:: as any*/),
          (v8/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "private",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shortDescription",
            "storageKey": null
          },
          {
            "alias": "version",
            "args": null,
            "concreteType": "DatasetVersion",
            "kind": "LinkedField",
            "name": "latestVersion",
            "plural": false,
            "selections": [
              (v7/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "license",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DatasetVersionAuthorConnection",
                "kind": "LinkedField",
                "name": "authors",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "displayName",
                            "storageKey": null
                          }
                        ],
                        "type": "User",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "displayName",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fullName",
                            "storageKey": null
                          }
                        ],
                        "type": "UnregisteredUser",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v10/*:: as any*/),
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DatasetVersionFileConnection",
                "kind": "LinkedField",
                "name": "files",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DatasetVersionFile",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v6/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "size",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DOI",
                "kind": "LinkedField",
                "name": "doi",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "full",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaggableConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Tag",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v9/*:: as any*/),
                  (v6/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          (v6/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ea756bc80978bb72ef575c08f587fb06",
    "id": null,
    "metadata": {},
    "name": "DatasetOverviewPageQuery",
    "operationKind": "query",
    "text": "query DatasetOverviewPageQuery(\n  $owner: String!\n  $slug: String!\n) {\n  datasetBySlug(owner: $owner, localSlug: $slug) {\n    viewerCanUpdate: viewerCan(action: UPDATE_DATASET)\n    versions(first: 1) {\n      nodes {\n        viewerCanUpdate: viewerCan(action: UPDATE_DATASET_VERSION)\n        ...DatasetVersionFragment\n        ...DatasetVersionEditSheet\n        id\n      }\n    }\n    ...DatasetHelmetFragment\n    id\n  }\n}\n\nfragment DatasetHelmetFragment on Dataset {\n  name\n  slug\n  private\n  shortDescription\n  version: latestVersion {\n    publishedAt\n    updatedAt\n    license\n    authors {\n      nodes {\n        __typename\n        ... on User {\n          displayName\n        }\n        ... on UnregisteredUser {\n          displayName: fullName\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n    files {\n      nodes {\n        id\n        size\n      }\n    }\n    doi {\n      url\n      full\n    }\n    id\n  }\n  tags {\n    nodes {\n      name\n      id\n    }\n  }\n  createdAt\n}\n\nfragment DatasetVersionEditFileFragment on DatasetVersion {\n  id\n  version\n  viewerCanCreateDatasetVersion: viewerCan(action: CREATE_DATASET_VERSION)\n  dataset {\n    slug\n    id\n  }\n}\n\nfragment DatasetVersionEditSheet on DatasetVersion {\n  id\n  version\n  dataset {\n    slug\n    id\n  }\n}\n\nfragment DatasetVersionFragment on DatasetVersion {\n  id\n  rows\n  schema\n  version\n  description\n  publishedAt\n  viewerCanUpdateDatasetVersion: viewerCan(action: UPDATE_DATASET_VERSION)\n  viewerCanCreateDatasetVersion: viewerCan(action: CREATE_DATASET_VERSION)\n  ...DatasetVersionTableFragment\n  ...DatasetVersionEditFileFragment\n  workspace {\n    id\n    editor {\n      id\n    }\n    ...WorkspaceViewFragment\n  }\n  dataset {\n    slug\n    name\n    id\n  }\n}\n\nfragment DatasetVersionTableFragment on DatasetVersion {\n  id\n  schema\n  rows\n  ...DatasetVersionEditFileFragment\n}\n\nfragment WorkspaceViewFragment on Node {\n  __isNode: __typename\n  id\n  ... on WorkspaceVersion {\n    publishedAt\n    viewerCanEdit: viewerCan(action: UPDATE_WORKSPACE)\n  }\n}\n"
  }
};
})();

(node as any).hash = "0050116bda469daff3b65589625b5cbe";

export default node;
